import { CapoPlugin } from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];